import Vue  from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let _resolveConfirm = null

export default new Vuex.Store({
  state: {
    toast: {
      visible:  false,
      mensaje:  '',
      tipo:     'info'  // success | error | warning | info
    },
    confirmar: {
      visible: false,
      titulo:  '',
      mensaje: ''
    },
    // Auth — se inicializa desde localStorage
    auth: {
      token:     localStorage.getItem('token')     || null,
      idUsuario: parseInt(localStorage.getItem('idUsuario') || '0'),
      nombre:    localStorage.getItem('nombre')    || '',
      email:     localStorage.getItem('email')     || '',
      idRol:     parseInt(localStorage.getItem('idRol')     || '0'),
      nombreRol: localStorage.getItem('nombreRol') || ''
    }
  },
  getters: {
    estaAutenticado: state => !!state.auth.token,
    esAdmin:         state => state.auth.idRol === 1,
    esCliente:       state => state.auth.idRol === 2,
    usuarioActual:   state => state.auth,
    confirmar:       state => state.confirmar
  },
  mutations: {
    MOSTRAR_TOAST (state, { mensaje, tipo = 'info' }) {
      state.toast.mensaje = mensaje
      state.toast.tipo    = tipo
      state.toast.visible = true
      setTimeout(() => { state.toast.visible = false }, 3500)
    },
    CERRAR_TOAST (state) {
      state.toast.visible = false
    },
    SET_CONFIRMAR (state, { titulo, mensaje }) {
      state.confirmar = { visible: true, titulo, mensaje }
    },
    HIDE_CONFIRMAR (state) {
      state.confirmar = { visible: false, titulo: '', mensaje: '' }
    },
    SET_AUTH (state, payload) {
      state.auth = { ...payload }
    },
    CLEAR_AUTH (state) {
      state.auth = { token: null, idUsuario: 0, nombre: '', email: '', idRol: 0, nombreRol: '' }
    }
  },
  actions: {
    mostrarToast ({ commit }, payload) {
      commit('MOSTRAR_TOAST', payload)
    },
    mostrarConfirm ({ commit }, { titulo = '¿Estás seguro?', mensaje }) {
      return new Promise(resolve => {
        _resolveConfirm = resolve
        commit('SET_CONFIRMAR', { titulo, mensaje })
      })
    },
    responderConfirm ({ commit }, respuesta) {
      commit('HIDE_CONFIRMAR')
      if (_resolveConfirm) {
        _resolveConfirm(respuesta)
        _resolveConfirm = null
      }
    },
    guardarAuth ({ commit }, payload) {
      localStorage.setItem('token',     payload.token)
      localStorage.setItem('idUsuario', payload.idUsuario)
      localStorage.setItem('nombre',    payload.nombre)
      localStorage.setItem('email',     payload.email)
      localStorage.setItem('idRol',     payload.idRol)
      localStorage.setItem('nombreRol', payload.nombreRol)
      commit('SET_AUTH', payload)
    },
    cerrarSesion ({ commit }) {
      localStorage.clear()
      commit('CLEAR_AUTH')
    }
  },
  modules: {}
})
